<template>
  <div class="anomaly-reports">
    <div class="container">

      <!-- Parameters -->
      <Panel class="configurations" :title="$t('parameters')" collapsible>
        <div class="columns">
          <div class="column">
            <div class="group" v-if="contextServer">
              <label>{{$t('server')}}</label>
              <input type="text" :value="contextServer.name" disabled>
            </div>
            <div class="group">
              <label>{{$t('branch.title')}}</label>
              <AjaxSelect
                v-model="branch"
                api="/api/entity/branch/select"
                :map-fn="b => b.name"
                :allow-empty-search="true"
              />
            </div>
            <div class="group" v-if="branch.id">
              <label>{{$t('branch.company')}}</label>
              <AjaxSelect
                v-model="company"
                api="/api/entity/company/select"
                :query="{branch: branch.id}"
                :map-fn="c => c.name"
                :allow-empty-search="true"
              />
            </div>
          </div>

          <div class="column">
            <div class="group">
              <label>From date (performance consideration)</label>
              <datetime
                v-model="start"
                :max-datetime="today"
                value-zone="local"
                input-style="width: 100%"
              />
            </div>
          </div>
        </div>

        <div class="buttons">
          <button class="btn btn-primary" @click="generate">{{$t('generate')}}</button>
          <button class="btn btn-secondary" @click="clearParameters">Clear parameters</button>
        </div>
      </Panel>

      <!-- Response -->
      <Panel v-if="builtData">
        <RawTable v-if="builtData" :columns="builtData.columns" :rows="builtData.data" :key-value-header="builtData.options.filters"/>
      </Panel>

    </div>
  </div>
</template>

<script>
  import AjaxSelect from "@/components/tools/AjaxSelect";
  import RawTable from "@/components/RawTable";
  import {Core} from "@/core/Core";
  import {DateTime} from "luxon";

  export default {
    name: "AnomalyReports",
    components: { AjaxSelect, RawTable },

    data() {
      return {
        company: {id: null},
        branch: {id: null},
        start: DateTime.local().minus({days: 30}).toISO(),
        today: DateTime.local().toISO(),
        builtData: null
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.anomaly_reports";
      this.$store.state.pageIcon = "/icon/nav/bug.svg";
    },

    computed: {
      contextServer() {
        return this.$store.state.contextServer;
      },
    },

    watch: {
      "branch.id"() {
        this.company = {id: null};
      },
      contextServer() {
        this.branch = {id: null};
      }
    },

    methods: {
      clearParameters() {
        this.branch = {id: null};
        this.start = null;
      },
      fixDateTime(dateString) {
        return dateString ? dateString.substring(0, 19).replace('T', ' ') : null;
      },
      async generate() {
        let data = {
          filters: {
            branch: this.branch.id || undefined,
            company: this.company.id || undefined,
            start: this.fixDateTime(this.start) || undefined
          }
        };
        try {
          showSpinner();
          let response = await Core.request("POST", `/api/stats-builder/sale-anomalies`, data);
          hideSpinner();
          if (response) {
            this.builtData = response;
          }
        } catch (e) {
          console.log(e);
          toast(e, "error");
          hideSpinner();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.buttons {
  button:not(:last-child) {
    margin-right: 10px;
  }
}
</style>